import { SerializableObject } from '../../common-react/core';


export class BankInfo extends SerializableObject {
    public IdentificationNumber: string;
    public AccountNumber: string;
    public AccountBank: string;
    public AccountType: string;
    public AccountIdentificationNumber: string;
}
